<template>
<footer class="padding-top-120">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class="footer-left-content">
                <div class="logo-colored">
                  <img src="images/Logo.png" alt="">{{footerData.logo_title}}
                </div>
                <div class="content">
                  <!-- <p class="margin-bottom-30 margin-top-30">Built using the latest web technologies like css3, and jQuery, rest assured Sedna look.</p>
                  <p>+88456895872, +88456595572</p>
                  <p>example@mail.com. lazyfox@mail.com</p> -->
                </div>
              </div>
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-3 col-sm-6">
                  <div class="footer-list-wiget" v-html="footerData.part_one">
                    
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="footer-list-wiget" v-html="footerData.part_two">
                    
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="footer-list-wiget" v-html="footerData.part_three">

                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="footer-list-wiget" v-html="footerData.part_four">

                  </div>
                </div>
                </div>
              </div>
            </div>
            <hr class="footer-divider">
            <div class="copyright-cta">
              <p class="text-uppercase" style="font-size:12px; text-align:center">Copyright © 2012 赛尔姆信息科技有限公司 <a target="_blank" href="http://beian.miit.gov.cn">粤ICP备13047521号</a></p>
            </div>
          </div>
   
        <div class="footer-end-line"></div>
      </footer>
      
</template>

<script>
export default {
  name: 'homefoot',
  props:['footerData']
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue